import type { Template } from "@/types";

export const LA_06_H4_V2: Template[] = [
{
    id: "la-06-h4v2-01",
    name: "LA 01 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 90, y: 49, width: 456, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 325, width: 147, height: 102, rotation: 0, imageRotation: 0 },
            { id: "3", x: 245, y: 325, width: 147, height: 102, rotation: 0, imageRotation: 0 },
            { id: "4", x: 400, y: 325, width: 147, height: 102, rotation: 0, imageRotation: 0 },
            { id: "5", x: 697, y: 49, width: 255, height: 376, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 49, width: 254, height: 376, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-02",
    name: "LA 02 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 90, y: 44, width: 453, height: 247, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 299, width: 223, height: 133, rotation: 0, imageRotation: 0 },
            { id: "3", x: 320, y: 299, width: 222, height: 133, rotation: 0, imageRotation: 0 },
            { id: "4", x: 815, y: 44, width: 281, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 815, y: 243, width: 138, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 243, width: 137, height: 189, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-03",
    name: "LA 03 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 144, y: 47, width: 160, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 144, y: 280, width: 113, height: 151, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 280, width: 220, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 311, y: 47, width: 172, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 311, y: 164, width: 172, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 711, y: 75, width: 489, height: 325, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-04",
    name: "LA 04 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 106, y: 36, width: 270, height: 404, rotation: 0, imageRotation: 0 },
            { id: "2", x: 384, y: 244, width: 142, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 384, y: 36, width: 142, height: 97, rotation: 0, imageRotation: 0 },
            { id: "4", x: 384, y: 140, width: 142, height: 97, rotation: 0, imageRotation: 0 },
            { id: "5", x: 788, y: 36, width: 335, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 788, y: 243, width: 335, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-05",
    name: "LA 05 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 80, y: 39, width: 273, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 80, y: 243, width: 273, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 39, width: 273, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 243, width: 273, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 39, width: 272, height: 397, rotation: 0, imageRotation: 0 },
            { id: "6", x: 922, y: 39, width: 272, height: 397, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-06",
    name: "LA 06 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 53, y: 39, width: 301, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 243, width: 301, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 39, width: 272, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 39, width: 301, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 243, width: 301, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 950, y: 39, width: 273, height: 399, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-07",
    name: "LA 07 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 53, y: 39, width: 301, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 243, width: 301, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 39, width: 272, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 39, width: 273, height: 399, rotation: 0, imageRotation: 0 },
            { id: "5", x: 923, y: 39, width: 301, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 923, y: 243, width: 301, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-08",
    name: "LA 08 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 33, y: 64, width: 241, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 459, y: 64, width: 241, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 707, y: 64, width: 534, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 281, y: 64, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 281, y: 182, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 281, y: 302, width: 172, height: 113, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-09",
    name: "LA 09 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 33, y: 64, width: 534, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 574, y: 64, width: 241, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 822, y: 64, width: 241, height: 351, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1070, y: 64, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 182, width: 172, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1070, y: 302, width: 172, height: 113, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h4v2-10",
    name: "LA 10 - H4V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 156, y: 34, width: 604, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 34, width: 145, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 242, width: 145, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 920, y: 34, width: 199, height: 131, rotation: 0, imageRotation: 0 },
            { id: "5", x: 920, y: 172, width: 199, height: 131, rotation: 0, imageRotation: 0 },
            { id: "6", x: 920, y: 310, width: 199, height: 131, rotation: 0, imageRotation: 0 }
    ],
}
];